$(document).ready(function() {
  setTimeout(function(){
    $('.product-page--thumbs-container .product-page--thumb:first-child img').click(); 
  }, 1000);

  // Put default value of variants in custom buttons 
  var hidden_sel_val = $.trim($('#variant-listbox').find(":selected").text());
  var hidden_sel_val_split = hidden_sel_val.split("/");
  $(document).find('[data-id="variant-listbox-option-0"] .info-card-component__button-title').text(hidden_sel_val_split[0]);
  $(document).find('[data-id="variant-listbox-option-1"] .info-card-component__button-title').text(hidden_sel_val_split[1]);
  
    $(document).on('click', '.product-page--main-content .info-card-component__button-select', function(e) {
      e.preventDefault();
      $('.itg_popup_wr').addClass('visible');
      $('body').css('overflow', 'hidden');
    });
    $(document).on('click', '.itg_popup_overlay, .itg_close_btn', function() {
      $('.itg_popup_wr').removeClass('visible');
      $('body').css('overflow', 'auto');
    });

  
    // Product variant functionality

    // Custom Options select from sidebar
    $(document).on('click', '.product-page--main-content .info-card-component__button-select', function() {
      var btn_name = $(this).attr('data-name');
      $('#ivariant-listbox .option_name').each(function() {
          var option_val = $(this).attr('data-value');
          if (btn_name == option_val) {
              $(this).show();
          } else {
              $(this).hide();
          }
      });
    });

    // On select custom options change default select value for add to cart
    $(document).on('click', '.main_variants .option_name div', function() {
      var trim_sel_val = $.trim($(this).text());
      $('.itg_popup_wr').removeClass('visible');
      var sel_option_name = $(this).closest('.option_name').attr('data-value');
      var data_index = $(this).closest('.option_name').attr('data-index');
      console.log(sel_option_name);
      $('.itg_cus_btn button').each(function() {
          var main_btn = $(this).attr('data-name');
          console.log(main_btn);
          if (sel_option_name == main_btn) {
              $(this).find('.info-card-component__button-title').text(trim_sel_val);
          }
      });

      var trim_sel_val1 = $.trim($(this).text());
      $('#variant-listbox-option-'+ data_index + ' option').each(function() {
          var color_value = $(this).val();
          if (trim_sel_val1 == color_value) {
            $(this).prop("selected",true);
            $(this).change();
          } else {
              $(this).removeAttr('selected');
          }
      });

      $('body').css('overflow', 'auto');
    });


    $(window).resize(function () {
      progresScreen();
    });
    progresScreen();
    function progresScreen() {
    var width = $(window).width();
    if (width < 768) {
      //alert('done');
      $(".product-page--images-container").addClass("swiper mySwiper");
      $(".product-page--images-container .modal--root").addClass("swiper-wrapper");

      var swiper = new Swiper(".mySwiper", {
        speed: 1000,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        }
      });
     }
   }
new Ajaxinate({
  container: '#AjaxinateContainer',
  pagination: '#AjaxinatePagination',
  loadingText: 'Discover More',
});
    document.addEventListener("DOMContentLoaded", function() {
      var endlessScroll = new Ajaxinate();
    });
  
  // $(document).on('click', '.cstm_paginate a', function(e){
  //   e.preventDefault();
  //   var next_pg_url = $(this).attr('href');
  //   $(this).find('span').hide();
  //   $(this).find('img').show();
  //   $.ajax({
  //      type: 'GET',
  //      url: next_pg_url,
  //      dataType: "html",
  //      success: function(data) {
  //        var filteredData = $(data).find(".product-grid--root").html();
  //        $(document).find(".product-grid--root").append(filteredData); 
  //        var next_pg_url1 = $(data).find(".cstm_paginate").html();
  //        $(document).find(".cstm_paginate").html(next_pg_url1); 
  //        window.history.pushState('obj', 'newtitle', next_pg_url);
  //        $(document).find(".cstm_paginate a span").show();
  //        $(document).find(".cstm_paginate a img").hide();
         
  //        var paginate_class =  $(data).find(".pagination li:last-child").hasClass('unavailable');
  //        if(paginate_class == true){
  //          $(document).find(".cstm_paginate").hide();
  //        }else{
  //           $(document).find(".cstm_paginate").show()
  //        }
  //      }
  //  });
  // });
  
});

